<template>
  <div>صفحه فروشگاه</div>
</template>

<script>
export default {
  name: "Store"
}
</script>

<style scoped>

</style>